import ability from './ability'

export const canNavigate = to =>
  to.matched.some(route => {
    const action = route.meta.action || 'read'
    const resource = route.meta.resource

    // meta.roles tanımlıysa, kullanıcının rolü listede olmalı (resource kontrolünden bağımsız)
    if (route.meta.roles) {
      const userData = JSON.parse(localStorage.getItem('userData') || 'null')
      if (!userData || !route.meta.roles.includes(userData.role)) return false
    }

    // Public routes should always be reachable, even for logged-in users whose
    // server-provided ability rules might not include `Public`.
    //meta.resource: "Public" olan route’lar her zaman erişilebilir
    if (resource === 'Public') return true

    return ability.can(action, resource)
  })

export const _ = undefined
